import { blockCategories } from '../categories';

const COMPONENT_TYPE = 'field-wrapper';
const BLOCK_ID = 'field-wrapper';

const getFieldLabel = (fieldValue, fieldOptions = []) => {
    const option = fieldOptions.find((entry) => entry.value === fieldValue);
    return option?.name ?? fieldValue;
};


export default function fieldWrapper(editor, {
    fieldOptions = [],
    defaultField = 'title',
    category = blockCategories.teaser,
} = {}) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;
    const defaultLabel = getFieldLabel(defaultField, fieldOptions);

    domComponents.addType(COMPONENT_TYPE, {
        model: {
            defaults: {
                tagName: 'div',
                name: `Field: ${defaultField}`,
                droppable: true,
                draggable: true,
                stylable: true,
                highlightable: true,
                attributes: {
                    class: 'sio-field-wrapper',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field': defaultField,
                    'data-field-label': defaultLabel,
                },
                field: defaultField,
                traits: [
                    {
                        type: 'selectize',
                        name: 'field',
                        label: 'Feld',
                        options: fieldOptions,
                        changeProp: 1,
                        default: defaultField,
                        placeholder: 'Feld suchen…',
                    },
                ],
                components: [],
            },

            init() {
                this.syncFieldFromAttributes();
                this.on('change:field', this.onFieldChange);
                this.on('change:attributes', this.onAttributesChange);
            },

            syncFieldFromAttributes() {
                const attrs = this.getAttributes() || {};
                const field =
                    attrs['data-field'] || this.get('field') || defaultField;
                this.set('field', field, { silent: true });
                this.applyField(field);
            },

            onAttributesChange() {
                const attrs = this.getAttributes() || {};
                const field = attrs['data-field'];
                if (field && field !== this.get('field')) {
                    this.set('field', field, { silent: true });
                    this.applyField(field, { skipAttributes: true });
                }
            },

            onFieldChange() {
                this.applyField(this.get('field') || defaultField);
            },

            applyField(field, { skipAttributes = false } = {}) {
                const label = getFieldLabel(field, fieldOptions);

                if (!skipAttributes) {
                    this.addAttributes({
                        'data-field': field,
                        'data-field-label': label,
                    });
                } else {
                    this.addAttributes({ 'data-field-label': label });
                }

                // Layers panel only — not shown on the canvas blueprint
                this.set('name', `Field: ${field}`);
            },
        },

        view: {},
    });

    blockManager.add(BLOCK_ID, {
        label: 'Feld-Wrapper',
        category,
        media: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.5" stroke-dasharray="3 2"/>
            <path fill="currentColor" d="M7 8h10v1.5H7V8zm0 3.5h7V13H7v-1.5zm0 3.5h10V16.5H7V15z"/>
        </svg>`,
        content: {
            type: COMPONENT_TYPE,
            field: defaultField,
            attributes: {
                class: 'sio-field-wrapper',
                'data-siotype': COMPONENT_TYPE,
                'data-field': defaultField,
                'data-field-label': defaultLabel,
            },
        },
    });
}
